import { CancelButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { useApiUtils } from '@core/util/apiUtils';
import { Grid } from '@material-ui/core';
import boletoApi from 'app/services/api/boletoApi';
import * as Actions from 'app/store/actions';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ContaReceberContext } from '../../contaReceberContext';

const ContaReceberErrosPartnerBankModal = (props) => {
  const { openModal, onCloseModal, contaReceberConciliacaoId } = props;
  const [contaReceberId, setContaReceberId] = useContext(ContaReceberContext).contaReceberId;
  const [erros, setErros] = useState('');
  const [, setLoading] = useContext(ContaReceberContext).loading;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const buscarErros = async () => {
    if (contaReceberId || contaReceberConciliacaoId) {
      try {
        setLoading(true);

        let response;

        if (contaReceberId) {
          response = await boletoApi.buscarErrosBoleto(contaReceberId);
        } else if (contaReceberConciliacaoId) {
          response = await boletoApi.buscarErrosBoleto(contaReceberConciliacaoId);
        }

        setErros(response.data);
      } catch (err) {
        setLoading(false);

        apiUtils.handleApiError(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const onInit = () => {
    buscarErros();
  };

  useEffect(onInit, [contaReceberId, contaReceberConciliacaoId]);

  const handleCloseModal = () => {
    setContaReceberId(undefined);
    onCloseModal();
  };

  return (
    <SimpleDialog open={openModal} onClose={handleCloseModal} innerScroll>
      <FormDialogContent
        header={{
          title: 'Erros retornados pelo Partner Bank',
          toolbar: (
            <>
              <CancelButton title="cancelar" type="button" onClick={handleCloseModal}>
                Fechar
              </CancelButton>
            </>
          ),
        }}
        content={
          <Grid container>
            <Grid item xs={12}>
              {erros}
            </Grid>
          </Grid>
        }
      />
    </SimpleDialog>
  );
};

export default ContaReceberErrosPartnerBankModal;
